import {deleteWishlistItemTemplateURL} from "../../common/others/Configuration";
import rejectNonOkResponse from "../rejectNonOkResponse";

export default (wishlistPublicId, prid, catalog) => rejectNonOkResponse(fetch(
  deleteWishlistItemTemplateURL({wishlistPublicId, prid, catalog}),
  {
    method: 'DELETE',
    credentials: "include"
  }
)).then(() => true);
